import styled from "styled-components";

export const UnStyledButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  color: inherit;
`;
